import { CommonTranslationKey } from "../pages/main/content/CommonTranslationKey";
import {TranslationFunction} from "../store/localization/TranslMessasge";


export class BooleanFormatter {
    static formatAsYesNo(value: boolean | undefined | null, t: TranslationFunction): string {
        if (value === undefined || value === null) {
            return '';
        } else {
            return value ? t(CommonTranslationKey.YES) : t(CommonTranslationKey.NO);
        }
    }
}
